module.exports = __webpack_public_path__ + "assets/bd99a1cfbf5f3bae64805b27cf7221ff.mp3";